import { render, staticRenderFns } from "./AzconSliderSkeleton.vue?vue&type=template&id=5885f27b&scoped=true"
import script from "./AzconSliderSkeleton.vue?vue&type=script&lang=js"
export * from "./AzconSliderSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AzconSliderSkeleton.vue?vue&type=style&index=0&id=5885f27b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885f27b",
  null
  
)

export default component.exports